import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAward, FiTrendingUp, FiHeart } = FiIcons;

const SplitSection = () => {
  const badges = [
    { icon: FiAward, text: "7+ Years in Digital Marketing", color: "#FFD700" },
    { icon: FiTrendingUp, text: "300+ Campaigns Delivered", color: "#FFD700" },
    { icon: FiHeart, text: "95% Client Satisfaction", color: "#FFD700" }
  ];

  return (
    <section className="py-24 relative overflow-hidden" style={{ backgroundColor: '#3a1c40' }}>
      {/* Section is now transparent to show the global animated background */}
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <motion.h2 
              className="text-4xl md:text-5xl font-bold mb-8 text-white"
              animate={{ 
                textShadow: [
                  "0 0 0px rgba(177, 107, 189, 0)",
                  "0 0 15px rgba(177, 107, 189, 0.7)",
                  "0 0 0px rgba(177, 107, 189, 0)"
                ]
              }}
              transition={{
                duration: 3,
                repeat: Infinity
              }}
            >
              Your Digital Growth Partner
            </motion.h2>
            <p className="text-lg md:text-xl leading-relaxed text-purple-100">
              At <span className="font-semibold text-yellow-300">advertisingpandit.com</span>, we combine creativity, data, and AI to craft campaigns that deliver measurable ROI. Whether you're a startup or an enterprise, our team ensures your brand stands out in the crowded digital space.
            </p>
          </motion.div>

          {/* Right Badges */}
          <motion.div
            initial={{ x: 50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            {badges.map((badge, index) => (
              <motion.div
                key={index}
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
                whileHover={{ 
                  scale: 1.03,
                  boxShadow: '0 0 25px rgba(177, 107, 189, 0.4)'
                }}
                className="flex items-center space-x-6 p-6 bg-purple-900 bg-opacity-30 rounded-2xl backdrop-blur-sm border border-purple-800 hover:bg-opacity-40 transition-all duration-300"
              >
                <motion.div 
                  className="p-4 rounded-full" 
                  style={{ backgroundColor: badge.color }}
                  animate={{
                    boxShadow: [
                      "0 0 0px rgba(255, 215, 0, 0)",
                      "0 0 20px rgba(255, 215, 0, 0.6)",
                      "0 0 0px rgba(255, 215, 0, 0)"
                    ]
                  }}
                  transition={{
                    duration: 2,
                    delay: index * 0.3,
                    repeat: Infinity
                  }}
                >
                  <SafeIcon icon={badge.icon} className="text-2xl" style={{ color: '#3a1c40' }} />
                </motion.div>
                <span className="text-xl font-semibold" style={{ color: badge.color }}>
                  {badge.text}
                </span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SplitSection;